
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 30.6668H27.3333V9.3335H22V30.6668ZM23.3333 10.6668H26V29.3335H23.3333V10.6668Z"}}),_c('path',{attrs:{"d":"M12.6665 30.6668H17.9998V9.3335H12.6665V30.6668ZM13.9998 10.6668H16.6665V29.3335H13.9998V10.6668Z"}})])
          )
        }
      }
    